import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


@Pipe({ name: 'paymentEntityType' })
export class SubscriptionSetPaymentEntityTypePipe implements PipeTransform {

    constructor(@Inject(forwardRef(() => DomSanitizer)) private sanitizer: DomSanitizer) { }

    transform(partnerId: string, bypassSanitize?: boolean): any {
        let style;
        let label;
        if (partnerId) {
            style = "color: #026659;background-color: #03CCB126;";
            label = "PARTNER";
        } else {
            style = "color: #7B3E00;background-color: #F57B0026;";
            label = "CUSTOMER";
        }
        const result = `<div class="sm-status-badge" style="${style}">
                    ${label}
                </div>`;
        if (bypassSanitize) {
            return this.sanitizer.bypassSecurityTrustHtml(result);
        }
        return result;

    }
}